import { useAuth } from '@/components/auth/authProvider';
import { isPalmettoFinanceUser } from '@/components/auth/RequirePalmettoFinanceUser';
import FormSection from '@/components/Forms/FormSection';
import { useGetDocumentsQuery } from '@/services/documents';
import { CheckboxInput } from '@palmetto/palmetto-components';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { HVACInstallPackageFileCategory } from 'types';

import { DocumentList } from '../Documents/DocumentList';

interface WarrantyRegistrationProps {
  onValidityChange?: (isValid: boolean) => void;
  isPackageEditable?: boolean;
}

const WarrantyRegistration = ({ onValidityChange, isPackageEditable = true }: WarrantyRegistrationProps) => {
  const { claims } = useAuth();
  const isFinCoUser = isPalmettoFinanceUser(claims);
  const { id = '' } = useParams<{ id: string }>();

  const [isOemCheckboxChecked, setIsOemCheckboxChecked] = useState(false);

  const { data: oemWarrantyDocs = [] } = useGetDocumentsQuery({
    accountId: id,
    documentTypeFilter: [HVACInstallPackageFileCategory.oemWarrantyDocuments],
  });

  const isOemWarrantyFileUploaded = oemWarrantyDocs.length > 0;

  const handleCheckboxChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsOemCheckboxChecked(event.target.checked);
    },
    [setIsOemCheckboxChecked],
  );

  useEffect(() => {
    onValidityChange?.(isOemCheckboxChecked);
  }, [isOemCheckboxChecked, onValidityChange]);

  return (
    <>
      <FormSection title="OEM Warranties" description="Submit proof of warranty registration with manufacturer(s)">
        <CheckboxInput
          label="I have registered the system with the original equipment manufacturer(s)"
          name="oemWarrantyRegistered"
          id="oemWarrantyRegistered"
          isDisabled={!isOemWarrantyFileUploaded || !isPackageEditable}
          isChecked={isOemCheckboxChecked}
          onChange={handleCheckboxChange}
        />
        <DocumentList
          documentTypeFilter={[HVACInstallPackageFileCategory.oemWarrantyDocuments]}
          title="OEM Warranty Documents"
          showTypeLabelOnItems={false}
          showDocumentActions={isFinCoUser}
          showUploadButton={isFinCoUser}
          baseCategory={HVACInstallPackageFileCategory.oemWarrantyDocuments}
          isPackageEditable={isPackageEditable}
        />
      </FormSection>
    </>
  );
};

export default WarrantyRegistration;
